






























import { Vue, Component } from 'vue-property-decorator';
import Plant from "@/domainObjects/Plant";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";


@Component({
})
export default class PrintHoldTicketTable extends Vue {

    private holdTickets:HoldTicket[] = [];
    private fields:Fields[] = [];
    private totalRows:number = 0;
    private filter:string = '';
    private sortBy: string = '';
    private sortDesc: boolean = true;
    private isBusy = true;
    private plantCode: string = '0';

    constructor() {
        super();
        this.fields = [
            { key: 'holdTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc'},
            { key: 'productionOrderNum', label: 'Order Number', sortable: true, sortDirection: 'desc' },
            { key: 'quantityOnHold', label: 'QTY', sortable: true, sortDirection: 'desc'},
            { key: 'materialDesc', label: 'Material Description', sortable: true, sortDirection: 'desc' },
            { key: 'comments', label: 'Desc. of Non-conf', sortable: true, sortDirection: 'desc'},
            { key: 'disposition.desc', label: 'Disposition', sortable: true, sortDirection: 'desc' },
            { key: 'dispositionComments', label: 'Action Req', sortable: true, sortDirection: 'desc' },
            { key: 'daysOpen', label: 'Days Open', sortable: true, sortDirection: 'desc' },
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
            { key: 'salesOrderNumber', label: 'Sales Order Number', sortable: true, sortDirection: 'desc'},
        ];

    }

    created(){
        this.plantCode = this.$route.query['plantCode'];
        this.totalRows = this.holdTickets.length;
        this.filter = this.$route.query['filter'];
        this.sortBy = this.$route.query['sortBy'];
        this.sortDesc = Boolean(this.$route.query['sortDesc']);
        this.fetchHoldTickets();
    }

    fetchHoldTickets() {
        this.$store.dispatch(LoadingActions.LOADING, true);
        TicketService.getHoldTickets().then((response) => {
            for ( let readHoldTicket of response.data ) {
                let ticket = new HoldTicket();
                ticket.initFromObject(readHoldTicket);
                ticket.comments = this.formatLongString(ticket.comments);
                ticket.dispositionComments = this.formatLongString(ticket.dispositionComments);
                if (this.plantCode === "0" || this.plantCode === ""){
                    this.holdTickets.push(ticket);
                } else {
                    if (this.plantCode === ticket.plant.code){
                        this.holdTickets.push(ticket);
                    }
                }
            }
            this.toggleBusy();
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{
        });
    }

    formatLongString(value){
        if (typeof value === 'string' && value.length > 60){
            return value.substring(0,59) + '...'
        }
        return value;
    }

    toggleBusy() {
        this.isBusy = !this.isBusy;
    }
}

